import type { MouseEvent } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";
import type { DrivingSchoolCustomCard } from "../../providers/drivingSchoolCustomCardsProvider";

export function CustomCardMobileListItem(props: {
  customCard: DrivingSchoolCustomCard;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { customCard, onClick } = props;
  const theme = useTheme();

  return (
    <ButtonBase
      component="div"
      data-testid="CustomCardMobileListItem"
      onClick={onClick}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Row sx={{ alignItems: "flex-start", gap: 1.5, minWidth: 0 }}>
        <Box
          alt=""
          component="img"
          src={customCard.imageUrl}
          sx={{ borderRadius: 1, flexShrink: 0, height: 64, objectFit: "cover", width: 96 }}
        />
        <Column sx={{ gap: 0.25, minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
            {customCard.title}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
            {customCard.description}
          </Typography>
          {customCard.ctaLabel && (
            <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              Button: {customCard.ctaLabel}
            </Typography>
          )}
          {customCard.ctaLink && (
            <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              {customCard.ctaLink}
            </Typography>
          )}
        </Column>
      </Row>
    </ButtonBase>
  );
}
